if (!customElements.get('gg-style-compare')) {
  customElements.define('gg-style-compare',class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;
      const range=this.querySelector('input[type="range"]');
      const update=()=>this.style.setProperty('--gg-reveal',range.value+'%');
      range.addEventListener('input',update);
      update();
    }
  });
}
